import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { getSiteBrand } from "@/lib/siteHosts";
import { applyBrandDocument, loadAnalytics } from "@/lib/brandDocument";

const brand = getSiteBrand();
applyBrandDocument(brand);
loadAnalytics(brand);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
